import { Box } from '@chakra-ui/react';
import React from 'react';
import { ChooseTextProps } from '../../interfaces/components';

function ChooseText({ activeLocale, bgColor, chosen, content, setActive }: ChooseTextProps) {
  return (
    <Box
      zIndex="100"
      cursor="pointer"
      bg={bgColor}
      opacity={chosen ? 1 : 0.5}
      width="20px"
      height="20px"
      fontSize={['14px', '14px', '14px']}
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="100%"
      border={chosen ? '1px solid black' : 'unset'}
      fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
      onClick={setActive}
    >
      {content}
    </Box>
  );
}

export default ChooseText;
